export default "__VITE_ASSET__4a9e35e5__"